<app-code-view [isTitle]="true">
  <h4 Ctitle>
    {{ "ResourceManagement.Status" | localize }}
    <span class="f-s-14 f-w-400 d-block">{{ "ResourceManagement.CheckStatus" | localize }}</span>
    <mat-spinner
      *ngIf="isRefreshing"
      diameter="20"
      class="refresh-spinner">
    </mat-spinner>
  </h4>
  <div output>
    <mat-label class="f-s-14 f-w-600 d-block m-b-8 m-t-16">{{ "ResourceManagement.Filter" | localize }}</mat-label>
    <mat-form-field appearance="outline" class="w-100">
      <input matInput placeholder="{{'ResourceManagement.SearchText' | localize}}" #input (input)="applyFilter($event)" >
    </mat-form-field>
    <div class="table-responsive">
      <mat-table #table [dataSource]="dataSource" matSort matSortDisableClear (matSortChange)="sortPage($event)">
        <ng-container matColumnDef="select" *ngIf="enableSelection">
          <mat-header-cell *matHeaderCellDef>{{ 'ResourceManagement.OrganizationSelection.SelectFiles' | localize }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <input type="checkbox"
                   [checked]="isFileSelected(element.id)"
                   (change)="toggleFileSelection(element.id)">
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef style="flex-direction: column;" class="d-flex align-items-start">
            <mat-label class="p-b-5">
              {{ "ResourceManagement.Status" | localize }}
            </mat-label>
            <mat-select [(value)]="selectedStatus" (selectionChange)="filterByStatus($any($event.value))">
              @for (type of statusType; track type.toString()) {
                <mat-option [value]="type">
                  {{ `ResourceManagement.${type}` | localize }}
                </mat-option>
              }
            </mat-select>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <i-tabler
              *ngIf="element.status === 'FINISHED'"
              matTooltip="Finished"
              name="progress-check"
              class="text-success"
            ></i-tabler>
<!--            <i-tabler-->
<!--              *ngIf="element.status === 'PROCESSING'"-->
<!--              matTooltip="Processing"-->
<!--              name="progress-bolt"-->
<!--              class="text-muted"-->
<!--            ></i-tabler>-->
            <i-tabler
              *ngIf="element.status === 'PENDING'"
              matTooltip="Pending"
              name="rotate-clockwise-2"
              class="text-warning"
            ></i-tabler>
            <i-tabler
              *ngIf="element.status === 'FAILED'"
              matTooltip="Failed"
              name="progress-x"
              class="text-danger"
            ></i-tabler>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef>{{ "ResourceManagement.FileType" | localize }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <i-tabler matTooltip="{{ getFileTypeName(element) }}" name="{{getFileIcon(element)}}" [ngClass]="{'text-success': element.status === 'FINISHED', 'text-warning': element.status === 'PENDING', 'text-danger': element.status === 'FAILED'}"></i-tabler>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="title">
          <mat-header-cell *matHeaderCellDef>{{ "ResourceManagement.Title" | localize }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div matTooltip="{{ element?.title}}">
              {{ element?.title || "-"}}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef>{{ "ResourceManagement.Description" | localize }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div matTooltip="{{ element?.description}}">
              {{ element?.description || "-"}}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="file_metadata">
          <mat-header-cell *matHeaderCellDef>{{ "ResourceManagement.FileName" | localize }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div matTooltip="{{ element.metadata?.requested_file_name || element.metadata?.name || element.metadata?.file_name || element.metadata?.scraper_url || element.metadata?.qaData?.question}}" *ngIf="element.metadata?.requested_file_name || element.metadata?.name || element.metadata?.file_name || element.metadata?.scraper_url || element.metadata?.qaData?.question">
              {{ element.metadata?.requested_file_name || element.metadata?.name || element.metadata?.file_name || element.metadata?.scraper_url || element.metadata?.qaData?.question || "-"}}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="creator">
          <mat-header-cell *matHeaderCellDef>{{ "ResourceManagement.Creator" | localize }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.creatorFullName || '-' }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="createdDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Created Date">{{ "ResourceManagement.CreatedDate" | localize }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ (element.createdDate || element.created_date || element.createdAt || element.created_at) | dateTimezone:'medium':'utc' }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="updatedDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Updated Date">{{ "ResourceManagement.UpdatedDate" | localize }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ (element.updatedDate || element.updated_date || element.updatedAt || element.updated_at) | dateTimezone:'medium':'utc' }}
          </mat-cell>
        </ng-container>
<!--        <ng-container matColumnDef="labels">-->
<!--          <mat-header-cell *matHeaderCellDef>{{ "ResourceManagement.Labels" | localize }}</mat-header-cell>-->
<!--          <mat-cell *matCellDef="let element">-->
<!--            {{ (element.updatedDate || element.updated_date || element.updatedAt || element.updated_at) | dateTimezone:'medium':'utc' }}-->
<!--          </mat-cell>-->
<!--        </ng-container>-->
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ "ResourceManagement.Actions" | localize }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              (click)="deleteFile(element)"
              matTooltip="Dosyayı Sil"
              [disabled]="element.status === 'PENDING'"
              class="delete-button">
              <i-tabler name="trash" class="icon-18"></i-tabler>
            </button>
            <button
              *ngIf="element.metadata?.scraper_url"
              mat-icon-button
              (click)="viewMarkdownFile(element)"
              matTooltip="Markdown İçeriği Görüntüle"
              [disabled]="element.status !== 'FINISHED'"
              class="action-button">
              <i-tabler name="file-text" class="icon-18"></i-tabler>
            </button>
            <button
              *ngIf="element.metadata?.scraper_url"
              mat-icon-button
              (click)="goToFile(element)"
              matTooltip="Siteyi Görüntüle"
              class="action-button">
              <i-tabler name="corner-up-right-double" class="icon-18"></i-tabler>
            </button>
            <button
              *ngIf="element.metadata?.qaData"
              mat-icon-button
              (click)="viewQaDetails(element)"
              matTooltip="Soru-Cevap Detayını Görüntüle"
              [disabled]="element.status !== 'FINISHED'"
              class="action-button">
              <i-tabler name="help-circle" class="icon-18"></i-tabler>
            </button>
            <button
              *ngIf="!element.metadata?.scraper_url && !element.metadata?.qaData"
              mat-icon-button
              (click)="viewFile(element)"
              matTooltip="Dosyayı Görüntüle"
              [disabled]="element.status !== 'FINISHED'"
              class="action-button">
              <i-tabler name="eye" class="icon-18"></i-tabler>
            </button>

          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <tr class="mat-row" *matNoDataRow style="justify-content: center !important; display: flex;">
          <td colspan="6" *ngIf="isDataLoading" class="d-flex flex-col align-items-center justify-content-center">
            <mat-spinner diameter="40"></mat-spinner>
            <p>{{ "ResourceManagement.Loading" | localize }}</p>
          </td>
          <td *ngIf="!isDataLoading" class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center;">
            {{ "ResourceManagement.NoData" | localize }}
          </td>
        </tr>
      </mat-table>
      <mat-paginator *ngIf="dataSource?.data?.length" [pageSize]="pageSize" [length]="totalElements" [pageIndex]="currentPage" [pageSizeOptions]="[10, 20, 50]" (page)="onPageChange($event)" >
      </mat-paginator>
    </div>
  </div>
</app-code-view>
